export const moea_ic = {
    "header": {
        "changeLanguage": "Switch Language",
        "link": "Related Links",
        "regulation": "Investment Regulations",
        "guide": "User Guide",
        "register": "Register",
        "logIn": "Log In",
        "features": "System Features",
        "maintain": "Account Information Maintenance",
        "logOut": "Log Out",
        "inquiry": "Application Case Inquiry",
        "faq": "FAQ",
        "caseProgress": "Case Progress Search",
        "InvestDataMgmt": "Investment Managment"
    },
    "footer": {
        "issue": "For system operation issues, please call the customer service hotline.",
        "tel": "Tel",
        "hotline": "Overseas System Customer Service Hotline",
        "serviceHour": "Service Hours：Monday to Friday",
        "address": "Address：8F., No.7, Sec. 1, Roosevelt Rd., Jhongjheng District, Taipei City 100215, Taiwan (R.O.C.)"
    },
    "logInPage": {
        "announcement": "Latest Announcements",
        "loadAnnouncement": "Announcements are loading.",
        "view": "View All",
        "logIn": "Log In",
        "register": "Go to Register",
        "account": "Member Account",
        "enterAccount": "Please enter your ID number or email address",
        "password": "Password",
        "enterPassword": "Please enter your password",
        "forgot": "Forgot Password",
        "verifyCode": "Verification Code",
        "enterCode": "Please enter the verification code"
    },
    "homeAbout": {
        "applyCase": "Case Application",
        "applyDescribe": "It is divided into investment applications related to investment in Taiwan, foreign investment, and talent investment.",
        "apply": "Apply Here",
        "caseFolder": "Case Folder",
        "viewCase": "View your submission progress or case drafts.",
        "announcement": "Announcement",
        "seeMore": "See More",
    },
    "selectPlan": {
        "title": "Add New Application Case",
        "taiwan": "Investment in Taiwan",
        "foreign": "Foreign Investment",
        "investToChina": "Investment in Mainland China",
        "investToHk": "Investment in Hong Kong/Macau",
        "search": "Keyword Search",
        "noResult": "No relevant results found.",
        "a": "Form A",
        "aName": "First-time Investment Case (including new establishments)",
        "b_b1": "Form B / Form B-1",
        "b_b1Name": "Increase/Decrease Investment in Existing Business",
        "c": "Form C",
        "cName": "Application for Approval Case",
        "d": "Form D",
        "dName": "Equity Transfer",
        "e": "Form E",
        "eName": "Application for Name Change or Business Scope Change of Domestic Enterprise",
        "f": "Form F",
        "fName": "Application for Cancellation of Investment by Foreign/Overseas Chinese Company",
        "g": "Form G",
        "gName": "Application for Amendment of Foreign Investor’s Investment Plan",
        "h": "Form H",
        "hName": "Application for Reinvestment by Domestic Enterprise",
        "other": "Others",
        "otherName": "Modification / Termination / Withdrawal / Others",
        "apply": "Apply Here",
        "plan01": "First-time Investment Case (including new establishments)",
        "plan02": "Increase Investment in Existing Business",
        "plan03": "Application for Reducing Investment in the Original Investment Business",
        "plan04": "Application for Approval Case",
        "plan05": "Application Form for Renaming or Changing Business Items of a Domestic Business",
        "plan06": "Application Form for Foreign Investment Corporation Plan Modification",
        "plan07": "Domestic Business Reinvestment Application Form",
        "plan08": "Application Form for Project Amendment",
        "plan09": "Application Form for Extension of Implementation Period",
        "plan10": "Public Market Share Sale",
        "plan11": "Application Form for Renaming or Changing the Organizational Structure of a Reinvestment Business",
        "plan12": "Equity Transfer",
        "plan13": "Application for Dissolution/Cancellation of Investment Enterprise",
        "plan14": "Project Termination",
        "plan15": "Change of Investor’s Nationality or Identity",
        "foreign_01": "Form A",
        "foreign_01Name": "Foreign Investment Declaration Form A",
        "foreign_02": "Capital Reduction",
        "foreign_02Name": "Capital Reduction of Investment Enterprise",
        "foreign_03": "Cancellation",
        "foreign_03Name": "Cancellation of Investment Enterprise",
        "foreign_04": "Name Change",
        "foreign_04Name": "Name Change of Investment Enterprise or Investor",
        "foreign_05": "Filing for Record",
        "foreign_05Name": "Filing for Record of Outward Investment",
        "hkmo_01": "Form A",
        "hkmo_01Name": "Overseas Declaration Form A",
        "hkmo_02": "Capital Reduction",
        "hkmo_02Name": "Capital Reduction of Investment Enterprise",
        "hkmo_03": "Cancellation",
        "hkmo_03Name": "Cancellation of Investment Enterprise",
        "hkmo_04": "Name Change",
        "hkmo_04Name": "Name Change of Investment Enterprise or Investor",
        "hkmo_05": "Filing for Record",
        "hkmo_05Name": "Filing for Record of Investment in Hong Kong/Macau",
        "hkmo_06": "Technical Cooperation",
        "hkmo_06Name": "Technical Cooperation in Hong Kong/Macau",
        "china_01": "Form A",
        "china_01Name": "Mainland China Investment Declaration Form A",
        "china_02": "Capital Reduction",
        "china_02Name": "Capital Reduction of Mainland China Investment/Reinvestment",
        "china_03": "Profit Repatriation",
        "china_03Name": "Profit Repatriation from Mainland China Investment/Reinvestment",
        "china_04": "Case Cancellation",
        "china_04Name": "Case Cancellation of Mainland China Investment/Reinvestment",
        "china_05": "Change of Matters",
        "china_05Name": "Change of Matters for Mainland China Investment/Reinvestment",
        "china_06": "Implementation Status of Specially Reviewed Investment Project",
        "china_06Name": "Mainland China Investment Reporting - Implementation Status of Specially Reviewed Project",
        "china_07": "Implementation Status of Commitments",
        "china_07Name": "Mainland China Investment Reporting - Implementation Status of Commitments",
        "china_08": "Filing for Record",
        "china_08Name": "Filing for Record of Investment in Mainland China",
        "china_09": "Technical Cooperation",
        "china_09Name": "Technical Cooperation in Mainland China",
        "china_10": "Mainland China B",
        "china_10Name": "Mainland China Investment Declaration Form B (Simplified)",
        "china_11": "Mainland China C",
        "china_11Name": "Mainland China Investment Declaration Form C (Special Project)"
    }
}
